// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { TaTransparencyMetricFromJSON, TaTransparencyMetricToJSON, } from './';
export function TaTransparencyFromJSON(json) {
    return {
        'constituentCount': !exists(json, 'constituentCount') ? undefined : json['constituentCount'],
        'contributions': !exists(json, 'contributions') ? undefined : TaTransparencyMetricFromJSON(json['contributions']),
        'distributions': !exists(json, 'distributions') ? undefined : TaTransparencyMetricFromJSON(json['distributions']),
        'nav': !exists(json, 'nav') ? undefined : TaTransparencyMetricFromJSON(json['nav']),
    };
}
export function TaTransparencyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'constituentCount': value.constituentCount,
        'contributions': TaTransparencyMetricToJSON(value.contributions),
        'distributions': TaTransparencyMetricToJSON(value.distributions),
        'nav': TaTransparencyMetricToJSON(value.nav),
    };
}
